import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import { eventTypeColors } from './eventBlock';

@observer
class TvRadioProducerHelp extends Component {
    closeDrawer = () => {
        const { stores, drawerLevel = 1 } = this.props;
        const { appState } = stores;
        appState.toggleDrawer(false, drawerLevel);
    }

    render() {
        const { userStore } = this.props.stores;
        const { isAdmin, isCustomerAdmin } = userStore;
        const canEdit = isAdmin || isCustomerAdmin;

        return (
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                    <h5 class='ms-3 mb-3'>
                        <i class='fa-duotone fa-circle-question me-2' />
                        <Text id='tvradioproducer.helpTitle'>How the TV/Radio producer works</Text>
                    </h5>

                    {/* The flow */}
                    <div class='mx-3 p-3 rounded bg-body-secondary'>
                        <h6 class='mb-3'><Text id='tvradioproducer.helpFlowTitle'>How it works</Text></h6>
                        <ol class='mb-0 ps-3'>
                            {canEdit && (
                                <li class='mb-2'>
                                    <strong><Text id='tvradioproducer.helpStep1Title'>Create channels</Text></strong>
                                    <div class='text-body-secondary small'>
                                        <Text id='tvradioproducer.helpStep1Text'>Each channel becomes a column in the grid. Use the plus button next to the channel selector.</Text>
                                    </div>
                                </li>
                            )}
                            <li class='mb-2'>
                                <strong><Text id='tvradioproducer.helpStep2Title'>Choose channels, date and number of days</Text></strong>
                                <div class='text-body-secondary small'>
                                    <Text id='tvradioproducer.helpStep2Text'>Use the channel selector, date navigator and the days selector at the top to control what is shown.</Text>
                                </div>
                            </li>
                            {canEdit && (
                                <li class='mb-2'>
                                    <strong><Text id='tvradioproducer.helpStep3Title'>Add events</Text></strong>
                                    <div class='text-body-secondary small'>
                                        <Text id='tvradioproducer.helpStep3Text'>Click an empty cell at the desired time, or use the new event button (starts at 06:00 on the first selected channel).</Text>
                                    </div>
                                </li>
                            )}
                            {canEdit && (
                                <li class='mb-2'>
                                    <strong><Text id='tvradioproducer.helpStep4Title'>Adjust the schedule</Text></strong>
                                    <div class='text-body-secondary small'>
                                        <Text id='tvradioproducer.helpStep4Text'>Drag a block to move it (snaps to 15 minutes, also across channels). Drag the bottom edge of a block to change its duration.</Text>
                                    </div>
                                </li>
                            )}
                            {canEdit && (
                                <li class='mb-2'>
                                    <strong><Text id='tvradioproducer.helpStep5Title'>Streams</Text></strong>
                                    <div class='text-body-secondary small'>
                                        <Text id='tvradioproducer.helpStep5Text'>Turn on the Streams toggle at the top to show the stream column. Click in the column to schedule a new stream, or click an existing one to edit it.</Text>
                                    </div>
                                </li>
                            )}
                            <li class='mb-2'>
                                <strong><Text id='tvradioproducer.helpStep6Title'>Program list</Text></strong>
                                <div class='text-body-secondary small'>
                                    <Text id='tvradioproducer.helpStep6Text'>Click a channel name in the grid to open a print-friendly program list.</Text>
                                </div>
                            </li>
                            <li>
                                <strong><Text id='tvradioproducer.helpStep7Title'>Export CSV</Text></strong>
                                <div class='text-body-secondary small'>
                                    <Text id='tvradioproducer.helpStep7Text'>Download the whole schedule as CSV (semicolon separated, Excel compatible).</Text>
                                </div>
                            </li>
                        </ol>
                    </div>

                    {/* Legend */}
                    <div class='mx-3 mt-3 p-3 rounded bg-body-secondary'>
                        <h6 class='mb-3'><Text id='tvradioproducer.helpLegendTitle'>Symbols and colors</Text></h6>
                        <ul class='list-unstyled mb-3'>
                            <li class='mb-1'>
                                <span class='me-2' style='display: inline-block; width: 24px; height: 3px; background-color: #dc3545; vertical-align: middle;' />
                                <Text id='tvradioproducer.helpLegendNow'>Red line: current time</Text>
                            </li>
                            <li class='mb-1'>
                                <span class='me-2' style='display: inline-block; width: 24px; height: 3px; background-color: #22c55e; vertical-align: middle;' />
                                <Text id='tvradioproducer.helpLegendScrub'>Green line: the time under the mouse pointer</Text>
                            </li>
                            <li class='mb-1'>
                                <i class='fa-solid fa-bars-staggered me-2 text-body-secondary' style='width: 24px;' />
                                <Text id='tvradioproducer.helpLegendMultiday'>Striped edge: the event continues from the previous / into the next day</Text>
                            </li>
                            <li class='mb-1'>
                                <i class='fa-solid fa-lock me-2 text-body-secondary' style='width: 24px;' />
                                <Text id='tvradioproducer.helpLegendLock'>Lock icon: fixed start time (hard timing)</Text>
                            </li>
                        </ul>
                        <div class='small'>
                            <strong class='d-block mb-2'><Text id='tvradioproducer.helpLegendTypes'>Event types:</Text></strong>
                            <div class='d-flex flex-wrap gap-2'>
                                {Object.entries(eventTypeColors).map(([type, color]) => (
                                    <span key={type} class='badge' style={{ backgroundColor: color }}>
                                        <Text id={`tvradioproducer.helpType-${type}`}>{type}</Text>
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Close button */}
                    <div class='w-100 d-flex flex-column justify-content-start mt-3 px-4 py-3 bg-light fixed-bottom' style='bottom: 0; left: 0;'>
                        <button type='button' class='btn btn-secondary rounded-pill' onClick={this.closeDrawer}>
                            <i class='fa-solid fa-times me-2' />
                            Lukk
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default TvRadioProducerHelp;
